




























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import {
  TaskAdd,
  ExpantionState,
  CustomAttribute,
  TaskName,
  DefaultCreateTaskAttributes,
  TaskAttribute,
  Representative,
  CustomAttributeType,
  CustomTile,
  AttributeKey,
  TaskDetailParam,
  SelectTaskList,
  TaskChildViewAttributeGroup,
  TaskAttributeGroup,
} from '@/@types/LibraryComponent';
import DebugUserIcon from '@/components/common/DebugUserIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import PersonMenu from '@/components/taskList/taskListTableParts/PersonMenu.vue';
import DatePickerParts from '@/components/taskList/taskAddModal/DatePickerParts.vue';
import SelectMenu from '@/components/taskList/taskListTableParts/SelectMenu.vue';
import AccentSelectMenu from '@/components/taskList/taskListTableParts/AccentSelectMenu.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import {
  CreateTaskParam,
} from '@/@types/Task';
import { vxm } from '@/store';
import { AttributeCd, ATTRIBUTE_STYLE } from '@/@types/constant';
import { Project } from '@/@types/Project';
import dayjs from 'dayjs';
import { valueof } from '@/@types/Common';

@Component({
  components: {
    DebugUserIcon,
    CommonButton,
    PersonMenu,
    DatePickerParts,
    SelectMenu,
    AccentSelectMenu,
    AccountIcon,
  },
})
export default class TaskAddModal extends Vue {
  @Prop({ required: true })
  private project!: Project | undefined;
  @Prop()
  private customAttributes!: CustomAttribute[];
  @Prop()
  private taskNames!: TaskName[];
  @Prop()
  private representatives!: Representative[];
  @Prop()
  private customTiles!: CustomTile[];
  @Prop({ required: true })
  private taskChildViewAttributeGroups!: TaskChildViewAttributeGroup[];
  @Prop()
  private priorities!: TaskAttributeGroup[];
  @Prop()
  private statuses!: TaskAttributeGroup[];
  @Prop()
  private categories!: TaskAttributeGroup[];
  private ownParentTaskId: number | null = null;
  private currentResponsiblePersonId: number | null = null;
  private practitionerId: number | null = null;
  private deadline: string | null = null;
  private startDate: string | null = null;
  private scheduledTime: number | null = null;
  private completedTime: number | null = null;
  private category: string | null = null;
  private priority: string | null = null;
  private status: string | null = null;
  private ticketUnitPrice: string | null = null;
  private milestone: string | null = null;
  private eventOccurrenceVersion: string | null = null;
  private completedReason: string | null = null;
  private supportPhase: string | null = null;
  private importance: string | null = null;
  private eventOccurrenceTiming: string | null = null;
  private eventSource: string | null = null;
  private supportScheduledDate: string | null = null;
  private releaseScheduledDate: string | null = null;
  private confirmationDate: string | null = null;

  private customAttribute1ValueOption: number | null = null;
  private customAttribute1ValueDate: string | null = null;
  private customAttribute1ValuePerson: number | null = null;
  private customAttribute1ValueText: string | null = null;
  private customAttribute1ValueNumber: number | null = null;
  private customAttribute2ValueOption: number | null = null;
  private customAttribute2ValueDate: string | null = null;
  private customAttribute2ValuePerson: number | null = null;
  private customAttribute2ValueText: string | null = null;
  private customAttribute2ValueNumber: number | null = null;
  private customAttribute3ValueOption: number | null = null;
  private customAttribute3ValueDate: string | null = null;
  private customAttribute3ValuePerson: number | null = null;
  private customAttribute3ValueText: string | null = null;
  private customAttribute3ValueNumber: number | null = null;
  private customAttribute4ValueOption: number | null = null;
  private customAttribute4ValueDate: string | null = null;
  private customAttribute4ValuePerson: number | null = null;
  private customAttribute4ValueText: string | null = null;
  private customAttribute4ValueNumber: number | null = null;
  private customAttribute5ValueOption: number | null = null;
  private customAttribute5ValueDate: string | null = null;
  private customAttribute5ValuePerson: number | null = null;
  private customAttribute5ValueText: string | null = null;
  private customAttribute5ValueNumber: number | null = null;
  private customAttribute6ValueOption: number | null = null;
  private customAttribute6ValueDate: string | null = null;
  private customAttribute6ValuePerson: number | null = null;
  private customAttribute6ValueText: string | null = null;
  private customAttribute6ValueNumber: number | null = null;
  private customAttribute7ValueOption: number | null = null;
  private customAttribute7ValueDate: string | null = null;
  private customAttribute7ValuePerson: number | null = null;
  private customAttribute7ValueText: string | null = null;
  private customAttribute7ValueNumber: number | null = null;
  private customAttribute8ValueOption: number | null = null;
  private customAttribute8ValueDate: string | null = null;
  private customAttribute8ValuePerson: number | null = null;
  private customAttribute8ValueText: string | null = null;
  private customAttribute8ValueNumber: number | null = null;
  private customAttribute9ValueOption: number | null = null;
  private customAttribute9ValueDate: string | null = null;
  private customAttribute9ValuePerson: number | null = null;
  private customAttribute9ValueText: string | null = null;
  private customAttribute9ValueNumber: number | null = null;
  private customAttribute10ValueOption: number | null = null;
  private customAttribute10ValueDate: string | null = null;
  private customAttribute10ValuePerson: number | null = null;
  private customAttribute10ValueText: string | null = null;
  private customAttribute10ValueNumber: number | null = null;
  private customAttribute11ValueOption: number | null = null;
  private customAttribute11ValueDate: string | null = null;
  private customAttribute11ValuePerson: number | null = null;
  private customAttribute11ValueText: string | null = null;
  private customAttribute11ValueNumber: number | null = null;
  private customAttribute12ValueOption: number | null = null;
  private customAttribute12ValueDate: string | null = null;
  private customAttribute12ValuePerson: number | null = null;
  private customAttribute12ValueText: string | null = null;
  private customAttribute12ValueNumber: number | null = null;
  private customAttribute13ValueOption: number | null = null;
  private customAttribute13ValueDate: string | null = null;
  private customAttribute13ValuePerson: number | null = null;
  private customAttribute13ValueText: string | null = null;
  private customAttribute13ValueNumber: number | null = null;
  private customAttribute14ValueOption: number | null = null;
  private customAttribute14ValueDate: string | null = null;
  private customAttribute14ValuePerson: number | null = null;
  private customAttribute14ValueText: string | null = null;
  private customAttribute14ValueNumber: number | null = null;
  private customAttribute15ValueOption: number | null = null;
  private customAttribute15ValueDate: string | null = null;
  private customAttribute15ValuePerson: number | null = null;
  private customAttribute15ValueText: string | null = null;
  private customAttribute15ValueNumber: number | null = null;
  private customAttribute16ValueOption: number | null = null;
  private customAttribute16ValueDate: string | null = null;
  private customAttribute16ValuePerson: number | null = null;
  private customAttribute16ValueText: string | null = null;
  private customAttribute16ValueNumber: number | null = null;
  private customAttribute17ValueOption: number | null = null;
  private customAttribute17ValueDate: string | null = null;
  private customAttribute17ValuePerson: number | null = null;
  private customAttribute17ValueText: string | null = null;
  private customAttribute17ValueNumber: number | null = null;
  private customAttribute18ValueOption: number | null = null;
  private customAttribute18ValueDate: string | null = null;
  private customAttribute18ValuePerson: number | null = null;
  private customAttribute18ValueText: string | null = null;
  private customAttribute18ValueNumber: number | null = null;
  private customAttribute19ValueOption: number | null = null;
  private customAttribute19ValueDate: string | null = null;
  private customAttribute19ValuePerson: number | null = null;
  private customAttribute19ValueText: string | null = null;
  private customAttribute19ValueNumber: number | null = null;
  private customAttribute20ValueOption: number | null = null;
  private customAttribute20ValueDate: string | null = null;
  private customAttribute20ValuePerson: number | null = null;
  private customAttribute20ValueText: string | null = null;
  private customAttribute20ValueNumber: number | null = null;
  private customAttribute21ValueOption: number | null = null;
  private customAttribute21ValueDate: string | null = null;
  private customAttribute21ValuePerson: number | null = null;
  private customAttribute21ValueText: string | null = null;
  private customAttribute21ValueNumber: number | null = null;
  private customAttribute22ValueOption: number | null = null;
  private customAttribute22ValueDate: string | null = null;
  private customAttribute22ValuePerson: number | null = null;
  private customAttribute22ValueText: string | null = null;
  private customAttribute22ValueNumber: number | null = null;
  private customAttribute23ValueOption: number | null = null;
  private customAttribute23ValueDate: string | null = null;
  private customAttribute23ValuePerson: number | null = null;
  private customAttribute23ValueText: string | null = null;
  private customAttribute23ValueNumber: number | null = null;
  private customAttribute24ValueOption: number | null = null;
  private customAttribute24ValueDate: string | null = null;
  private customAttribute24ValuePerson: number | null = null;
  private customAttribute24ValueText: string | null = null;
  private customAttribute24ValueNumber: number | null = null;
  private customAttribute25ValueOption: number | null = null;
  private customAttribute25ValueDate: string | null = null;
  private customAttribute25ValuePerson: number | null = null;
  private customAttribute25ValueText: string | null = null;
  private customAttribute25ValueNumber: number | null = null;
  private customAttribute26ValueOption: number | null = null;
  private customAttribute26ValueDate: string | null = null;
  private customAttribute26ValuePerson: number | null = null;
  private customAttribute26ValueText: string | null = null;
  private customAttribute26ValueNumber: number | null = null;
  private customAttribute27ValueOption: number | null = null;
  private customAttribute27ValueDate: string | null = null;
  private customAttribute27ValuePerson: number | null = null;
  private customAttribute27ValueText: string | null = null;
  private customAttribute27ValueNumber: number | null = null;
  private customAttribute28ValueOption: number | null = null;
  private customAttribute28ValueDate: string | null = null;
  private customAttribute28ValuePerson: number | null = null;
  private customAttribute28ValueText: string | null = null;
  private customAttribute28ValueNumber: number | null = null;
  private customAttribute29ValueOption: number | null = null;
  private customAttribute29ValueDate: string | null = null;
  private customAttribute29ValuePerson: number | null = null;
  private customAttribute29ValueText: string | null = null;
  private customAttribute29ValueNumber: number | null = null;
  private customAttribute30ValueOption: number | null = null;
  private customAttribute30ValueDate: string | null = null;
  private customAttribute30ValuePerson: number | null = null;
  private customAttribute30ValueText: string | null = null;
  private customAttribute30ValueNumber: number | null = null;
  private firstAttributeStyle: valueof<keyof typeof ATTRIBUTE_STYLE> | null = null;
  private firstAttributeKey: string = '';
  private firstAttribute: string = '';
  private firstAttributeNumber: number = 0;
  private firstAttributeValue: string | number | Date | null = null;

  private isOpenDeadlinePicker: boolean = false;
  private isOpenStartDatePicker: boolean = false;
  private isOpenSupportScheduledDatePicker: boolean = false;
  private isOpenReleaseScheduledDatePicker: boolean = false;
  private isOpenConfirmationDatePicker: boolean = false;

  /** 選択された子課題群のID配列 */
  private childTaskIds: number[] = [];

  /** 以下、課題の各カラム */
  private taskName: string = '';
  private taskDetail: string | null = null;
  private parentTaskId: number | null = null;
  private nextTaskId: number | null = null;
  private previousTaskId: number | null = null;

  private registrationPersonId: number | null = null;

  private freewordSearchText: string | null = null;

  private addCommonButtonColor: string = '#4384f3';
  private parentTaskList: SelectTaskList[] = [];
  private childTaskList: TaskName[] = [];
  private previousTaskList: TaskName[] = [];
  private ownParentTaskList: TaskName[] = [];
  private attributes: TaskAttribute[] = [];

  private tasksAlreadyUsed: TaskName[] = [];
  private taskSelectedOnPreviousTask: TaskName[] = [];

  /**
   * タスク詳細データ
   */
  private taskAdd: TaskAdd = require('@/repository/mock/dummyData/task/taskAdd.json')
    .taskAdd[0];
  /**
   * ↑ダミーデータ群
   */

  /**
   * 子課題リスト開閉ステータス定数
   */
  private readonly EXPANTION_STATE: ExpantionState = { OPEN: 0, CLOSE: 1 };

  /**
   * 子課題リスト開閉状態
   */
  private isExpandChildTasks: number = this.EXPANTION_STATE.CLOSE;
/**
   * タスク追加モーダルの表示状態
   */
  private isTaskAddModal: boolean = true;
  private isActive: boolean = false;

  /**
   * フォームバリデーション用プロパティ
   */
  private isInvalidScheduledTime: boolean = false;
  private isInvalidCompletedTime: boolean = false;
  private isInvalidTicketUnitPrice: boolean = false;
  private isInvalidMilestone: boolean = false;
  private isInvalidEventOccurrenceVersion: boolean = false;
  private isInvalidCompletedReason: boolean = false;
  private isInvalidSupportPhase: boolean = false;
  private isInvalidImportance: boolean = false;
  private isInvalidEventOccurrenceTiming: boolean = false;
  private isInvalidEventSource: boolean = false;
  private isInvalidCustom1Text: boolean = false;
  private isInvalidCustom1Number: boolean = false;
  private isInvalidCustom2Text: boolean = false;
  private isInvalidCustom2Number: boolean = false;
  private isInvalidCustom3Text: boolean = false;
  private isInvalidCustom3Number: boolean = false;
  private isInvalidCustom4Text: boolean = false;
  private isInvalidCustom4Number: boolean = false;
  private isInvalidCustom5Text: boolean = false;
  private isInvalidCustom5Number: boolean = false;
  private isInvalidCustom6Text: boolean = false;
  private isInvalidCustom6Number: boolean = false;
  private isInvalidCustom7Text: boolean = false;
  private isInvalidCustom7Number: boolean = false;
  private isInvalidCustom8Text: boolean = false;
  private isInvalidCustom8Number: boolean = false;
  private isInvalidCustom9Text: boolean = false;
  private isInvalidCustom9Number: boolean = false;
  private isInvalidCustom10Text: boolean = false;
  private isInvalidCustom10Number: boolean = false;
  private isInvalidCustom11Text: boolean = false;
  private isInvalidCustom11Number: boolean = false;
  private isInvalidCustom12Text: boolean = false;
  private isInvalidCustom12Number: boolean = false;
  private isInvalidCustom13Text: boolean = false;
  private isInvalidCustom13Number: boolean = false;
  private isInvalidCustom14Text: boolean = false;
  private isInvalidCustom14Number: boolean = false;
  private isInvalidCustom15Text: boolean = false;
  private isInvalidCustom15Number: boolean = false;
  private isInvalidCustom16Text: boolean = false;
  private isInvalidCustom16Number: boolean = false;
  private isInvalidCustom17Text: boolean = false;
  private isInvalidCustom17Number: boolean = false;
  private isInvalidCustom18Text: boolean = false;
  private isInvalidCustom18Number: boolean = false;
  private isInvalidCustom19Text: boolean = false;
  private isInvalidCustom19Number: boolean = false;
  private isInvalidCustom20Text: boolean = false;
  private isInvalidCustom20Number: boolean = false;
  private isInvalidCustom21Text: boolean = false;
  private isInvalidCustom21Number: boolean = false;
  private isInvalidCustom22Text: boolean = false;
  private isInvalidCustom22Number: boolean = false;
  private isInvalidCustom23Text: boolean = false;
  private isInvalidCustom23Number: boolean = false;
  private isInvalidCustom24Text: boolean = false;
  private isInvalidCustom24Number: boolean = false;
  private isInvalidCustom25Text: boolean = false;
  private isInvalidCustom25Number: boolean = false;
  private isInvalidCustom26Text: boolean = false;
  private isInvalidCustom26Number: boolean = false;
  private isInvalidCustom27Text: boolean = false;
  private isInvalidCustom27Number: boolean = false;
  private isInvalidCustom28Text: boolean = false;
  private isInvalidCustom28Number: boolean = false;
  private isInvalidCustom29Text: boolean = false;
  private isInvalidCustom29Number: boolean = false;
  private isInvalidCustom30Text: boolean = false;
  private isInvalidCustom30Number: boolean = false;


  private created() {
    this.parentTaskList = this.createParentTaskList(this.taskNames);
    this.childTaskList = this.taskNames;
    this.previousTaskList = this.taskNames;
    this.attributes = this.createTaskAttributes();
    this.ownParentTaskList = this.taskNames;
  }

  private changeDateValue(value: string | null, index: number) {
    this[`customAttribute${index}ValueDate`] = value;
  }

  private existsFirstAttribute() {
    if (this.project && this.project.customAttribute1Style) {
      return true;
    } else return false;
  }

  private existsAttribute(index: number) {
    if (this.attributes.length > index) {
      return true;
    } else {
      return false;
    }
  }

  private getCustomAttributeIndex(index: number) {
    if (index !== 0) {
      return index * 2;
    } else {
      return 0;
    }
  }

  private getStyle(attribute: TaskAttribute) {
    let style = 'date';
    switch (attribute.style) {
      case ATTRIBUTE_STYLE.PERSON:
        style = ATTRIBUTE_STYLE.PERSON;
        break;
      case ATTRIBUTE_STYLE.TEXT:
        style = ATTRIBUTE_STYLE.TEXT;
        break;
      case ATTRIBUTE_STYLE.OPTION:
        style = ATTRIBUTE_STYLE.OPTION;
        break;
      case ATTRIBUTE_STYLE.NUMBER:
        style = ATTRIBUTE_STYLE.NUMBER;
        break;
    }
    return style;
  }

  private getAttributeList(index: number) {
    const attributes = this.taskChildViewAttributeGroups.find((group) => {
      return group.attributeCd === `attribute${index}`;
    });
    if (attributes) {
      return attributes.attributes.map((attribute) => {
        return {
          text: attribute.title,
          value: attribute.taskAttributeValueOptionId,
        };
      });
    } else return [];
  }

  private valueToString(value: number | Date | null): string | null {
    if (typeof value === 'number') {
      return value.toString();
    } else if (value instanceof Date) {
      return dayjs(value).format('YYYY/MM/DD');
    } else {
      return value;
    }
  }

  /** 親課題用の課題リストを作成 */
  private createParentTaskList(taskNames: TaskName[]): SelectTaskList[] {
    return taskNames.map((task) => {
      return {
        taskId: task.value,
        taskName: task.text,
      };
    });
  }

  /** カスタム属性からTaskAttribute[]型を作成 */
  private createTaskAttributes() {
    let attributes: TaskAttribute[] = [];
    /** カスタム属性を取得 */
    if (this.customAttributes.length > 0) {
      this.customAttributes.forEach((attribute) => {
        /** カスタム属性を識別する数字 */
        const index = attribute.attributeNumber;
        let value: string | number | Date | null = null;
        let attributeKey: string = '';
        /** 属性の形式から、カスタム属性値を取得する */
        switch (attribute.style) {
          /** 日付形式 */
          case ATTRIBUTE_STYLE.DATE:
            attributeKey = `customAttribute${index}ValueDate`;
            break;
          /** 人物形式 */
          case ATTRIBUTE_STYLE.PERSON:
            attributeKey = `customAttribute${index}ValuePerson`;
            value = '担当者なし';
            break;
          /** テキスト形式 */
          case ATTRIBUTE_STYLE.TEXT:
            attributeKey = `customAttribute${index}ValueText`;
            break;
          /** 選択肢形式 */
          case ATTRIBUTE_STYLE.OPTION:
            attributeKey = `customAttribute${index}ValueOption`;
            break;
          /** 数値形式 */
          case ATTRIBUTE_STYLE.NUMBER:
            attributeKey = `customAttribute${index}ValueNumber`;
            break;
          default:
            break;
        }
        /** デフォルト属性の配列に結合するためのカスタム属性 */
        const customAttribute: TaskAttribute = {
          attribute: attribute.name,
          attributeKey: attributeKey,
          attributeNumber: attribute.attributeNumber,
          style: attribute.style,
          displayStyle: attribute.displayStyle,
          displayFlag: attribute.displayFlag,
          value: value,
          customFlag: true,
        };
        if (index !== 1) {
          attributes.push(customAttribute);
        } else {
          this.firstAttributeStyle = attribute.style;
          this.firstAttributeKey = attributeKey;
          this.firstAttribute = attribute.name;
          this.firstAttributeNumber = attribute.attributeNumber;
          this.firstAttributeValue = value;
        }
      });
    }
    return attributes;
  }


  /** 属性タイプがテキスト形式の場合trueを返す */
  private isAttributeStyle(attribute: TaskAttribute): boolean {
    return attribute.style === 'text' || attribute.style === 'number';
  }

  /**
   * 子課題リストの開閉
   */
  private toggleChildTasks(): void {
    if (this.isExpandChildTasks === this.EXPANTION_STATE.OPEN) {
      this.isExpandChildTasks = this.EXPANTION_STATE.CLOSE;
    } else {
      this.isExpandChildTasks = this.EXPANTION_STATE.OPEN;
    }
  }

  /**
   * 子課題リストの有無を見て、スクロールの高さをコントロールする
   */
  private toggleChildTasksScroll(): number {
    const taskLength: number = this.selectedTasks.length;
    if (taskLength === 0) {
      return 0;
    } else {
      return taskLength * 50;
    }
  }
  /**
   * 子課題リストの有無を見て、borderを表示する
   */
  private onDisplayBorder(): void {
    if (this.selectedTasks.length !== 0) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
  }

  // 子課題に変更があった場合、前課題と親課題で選択可能なリストを更新する
  private onChildTaskChanged(): void {
    let taskListUpdated = this.getTaskListNeverUsed();
    let currentSelectedTask = this.taskNames.find(
      (task) => task.value === this.previousTaskId
    );
    if (currentSelectedTask) {
      taskListUpdated.push(currentSelectedTask);
    }
    taskListUpdated.sort((a, b) => {
      return a.value - b.value;
    });
    this.previousTaskList = taskListUpdated;

    taskListUpdated = this.getTaskListNeverUsed();
    currentSelectedTask = this.taskNames.find(
      (task) => task.value === this.ownParentTaskId
    );
    if (currentSelectedTask) {
      taskListUpdated.push(currentSelectedTask);
    }
    taskListUpdated.sort((a, b) => {
      return a.value - b.value;
    });
    this.ownParentTaskList = taskListUpdated;

    this.onDisplayBorder();
  }

  /** 選択された子課題タイトルを取得 */
  private childTaskName(id: number) {
    const childTask = this.taskNames.find((task) => task.value === id);
    if (childTask) {
      return childTask.text;
    } else return;
  }

  /**
   * フォームバリデーション用メソッド
   */
  private checkValidScheduledTime() {
    if (this.scheduledTime) {
      this.isInvalidScheduledTime = Math.sign(this.scheduledTime) === -1 ? true : false;
    } else {
      this.isInvalidScheduledTime = false;
    }
  }

  private checkValidCompletedTime() {
    if (this.completedTime) {
      this.isInvalidCompletedTime = Math.sign(this.completedTime) === -1 ? true : false;
    } else {
      this.isInvalidCompletedTime = false;
    }
  }

  private checkValidTicketUnitPrice() {
    if (this.ticketUnitPrice) {
      this.isInvalidTicketUnitPrice = Math.sign(parseInt(this.ticketUnitPrice)) === -1 ? true : false;
    } else {
      this.isInvalidTicketUnitPrice = false;
    }
  }

  private checkValidMilestone() {
    if (this.milestone) {
      this.isInvalidMilestone = this.milestone.length > 32 ? true : false;
    }
  }

  private checkValidEventOccurrenceVersion() {
    if (this.eventOccurrenceVersion) {
      this.isInvalidEventOccurrenceVersion = this.eventOccurrenceVersion.length > 32 ? true : false;
    }
  }

  private checkValidCompletedReason() {
    if (this.completedReason) {
      this.isInvalidCompletedReason = this.completedReason.length > 32 ? true : false;
    }
  }

  private checkValidSupportPhase() {
    if (this.supportPhase) {
      this.isInvalidSupportPhase = this.supportPhase.length > 32 ? true : false;
    }
  }

  private checkValidImportance() {
    if (this.importance) {
      this.isInvalidImportance = this.importance.length > 32 ? true : false;
    }
  }

  private checkValidEventOccurrenceTiming() {
    if (this.eventOccurrenceTiming) {
      this.isInvalidEventOccurrenceTiming = this.eventOccurrenceTiming.length > 32 ? true : false;
    }
  }

  private checkValidEventSource() {
    if (this.eventSource) {
      this.isInvalidEventSource = this.eventSource.length > 32 ? true : false;
    }
  }

  // 親課題に変更があった場合、前課題と子課題で選択可能なリストを更新する
  private onParentTaskChanged(): void {
    const selectedTask = this.childTaskList.find(
      (task) => task.value === this.previousTaskId
    );
    let taskListUpdated = this.getTaskListNeverUsed();
    // 子課題で現在選択されているものを取得
    let tasksCurrentSelected = this.taskNames.filter((task) => {
      const found = this.childTaskIds.find((taskid) => task.value === taskid);
      if (found) {
        return true;
      }
      return false;
    });
    // 未使用タスクリストに現在選択されていものをマージ
    if (tasksCurrentSelected) {
      tasksCurrentSelected.forEach((task) => taskListUpdated.push(task));
    }
    // マージされた未使用タスクリストをソート
    taskListUpdated.sort((a, b) => {
      return a.value - b.value;
    });
    this.childTaskList = taskListUpdated;

    // 前課題の処理
    taskListUpdated = this.getTaskListNeverUsed();
    // 前課題で現在選択されているものを取得
    tasksCurrentSelected = this.taskNames.filter((task) => {
      if (task.value === this.previousTaskId) {
        return true;
      }
      return false;
    });
    // 未使用タスクリストに現在選択されていものをマージ
    if (tasksCurrentSelected) {
      tasksCurrentSelected.forEach((task) => taskListUpdated.push(task));
    }
    // マージされた未使用タスクリストをソート
    taskListUpdated.sort((a, b) => {
      return a.value - b.value;
    });
    this.previousTaskList = taskListUpdated;

    this.onDisplayBorder();
  }

  // 前課題に変更があった場合、子課題と親課題で選択可能なリストを更新する
  private onPreviousTaskChanged(): void {
    // 子課題の一覧にフィルタ処理を行う
    let taskListUpdated = this.getTaskListNeverUsed();
    // 子課題で現在選択されているものを取得
    let tasksCurrentSelected = this.taskNames.filter((task) => {
      const found = this.childTaskIds.find((taskid) => task.value === taskid);
      if (found) {
        return true;
      }
      return false;
    });
    // 未使用タスクリストに現在選択されていものをマージ
    if (tasksCurrentSelected) {
      tasksCurrentSelected.forEach((task) => taskListUpdated.push(task));
    }
    // マージされた未使用タスクリストをソート
    taskListUpdated.sort((a, b) => {
      return a.value - b.value;
    });
    this.childTaskList = taskListUpdated;

    // 親課題の一覧にフィルタ処理を行う
    taskListUpdated = this.getTaskListNeverUsed();
    // 親課題で現在選択されているものを取得
    tasksCurrentSelected = this.taskNames.filter((task) => {
      if (task.value === this.ownParentTaskId) {
        return true;
      }
      return false;
    });

    // 未使用タスクリストに現在選択されていものをマージ
    if (tasksCurrentSelected) {
      tasksCurrentSelected.forEach((task) => taskListUpdated.push(task));
    }
    // マージされた未使用タスクリストをソート
    taskListUpdated.sort((a, b) => {
      return a.value - b.value;
    });
    this.ownParentTaskList = taskListUpdated;

    this.onDisplayBorder();
  }

  //前課題、子課題、親課題に選ばれていないタスクの一覧を作る
  private getTaskListNeverUsed(): TaskName[] {
    const previousTask = this.taskNames.find(
      (task) => task.value === this.previousTaskId
    );
    const ownParentTask = this.taskNames.find(
      (task) => task.value === this.ownParentTaskId
    );
    let taskListFilterd: (TaskName | undefined)[] = [];

    //前課題に選択されている値をフィルタ
    taskListFilterd = this.taskNames.filter((task) => {
      if (previousTask) {
        if (task.value !== previousTask.value) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    });

    //親課題に選択されている値をフィルタ
    taskListFilterd = taskListFilterd.filter((task) => {
      if (ownParentTask) {
        if (task) {
          if (task.value !== ownParentTask.value) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return true;
      }
    });

    //子課題に選択されている値をフィルタ
    taskListFilterd = taskListFilterd.filter((task) => {
      if (task) {
        const found = this.childTaskIds.find(
          (childTaskId) => childTaskId === task!.value
        );
        if (!found) {
          return true;
        } else {
          return false;
        }
      }
    });

    const taskListUpdated: TaskName[] = [];
    taskListFilterd.forEach((task) => {
      if (task) {
        taskListUpdated.push(task);
      }
    });

    return taskListUpdated!;
  }

  private isParentTaskAttribute(attribute: TaskAttribute): boolean {
    return attribute.attributeKey === AttributeKey.parentTaskId;
  }

  private mergeInputValue(attribute: TaskAttribute, value: string) {
    const key: string = attribute.attributeKey;
    if (
      key === AttributeKey.scheduledTime ||
      key === AttributeKey.completedTime ||
      key === AttributeKey.ticketUnitPrice ||
      key.substr(-6, 6) === 'Number'
    ) {
      this[key] = Number(value);
    } else {
      this[key] = value;
    }
  }

  /** emitで送られてきたデータをプロパティに代入する */
  private mergeCreateTaskData(data: TaskDetailParam) {
    const key: string = data.attributeKey;
    this[key] = data.value;
  }

  private get accountId() {
    const response = vxm.theoryApi.authStore.getCurrentUserInfo;
    if (response) {
      return response.results.accountId as number;
    }
  }

  private get accountName() {
    const response = vxm.theoryApi.authStore.getCurrentUserInfo;
    if (response) {
      return response.results.accountName as string;
    }
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId;
  }

  private get projectName() {
    return vxm.theoryApi.authStore.getCurrentProjectName;
  }

  private get categoryList() {
    return this.categories.map((category) => {
      return category.title;
    });
  }

  private get priorityList() {
    return this.priorities.map((priority) => {
      return priority.title;
    });
  }

  private get statusList() {
    return this.statuses.map((status) => {
      return status.title;
    });
  }

  /**
   * 子課題追加で選択されたタスク
   */
  private get selectedTasks(): TaskName[] {
    let taskNames: TaskName[] = [];
    if (this.childTaskIds.length > 0) {
      this.childTaskIds.forEach((id) => {
        const task = this.childTaskList.find((task) => task.value === id);
        if (task) {
          taskNames.push(task);
        }
      });
    }
    return taskNames;
  }
  /**
   * 子課題リスト開閉状態の判定
   */
  private get arrowButtonRotate(): {
    'arrow-button--rotate': boolean;
  } {
    return {
      'arrow-button--rotate':
        this.isExpandChildTasks === this.EXPANTION_STATE.OPEN,
    };
  }
  /**
   * 子課題が１つ以上の時、border表示用のクラスをバインディングする。
   */
  private get childTasksActive(): {
    'child-tasks__active': boolean;
  } {
    return {
      'child-tasks__active': this.isActive,
    };
  }

  private get personList() {
    const representatives = this.representatives;
    return representatives.map((member) => {
      return {
        text: member.accountName,
        value: member.accountId,
      };
    });
  }

  @Emit('emitCreateTaskData')
  private emitCreateTaskData(): CreateTaskParam {
    let createTaskParam = {
      projectId: this.projectId,
      taskName: this.taskName,
      taskDetail: this.taskDetail,
      parentTaskId: this.parentTaskId,
      nextTaskId: this.nextTaskId,
      previousTaskId: this.previousTaskId,
      registrationPersonId: this.accountId as number,
      currentResponsiblePersonId: this.currentResponsiblePersonId,
      practitionerId: this.practitionerId,
      deadline: this.deadline,
      startDate: this.startDate,
      scheduledTime: this.scheduledTime
        ? Number((Number(this.scheduledTime) * 60).toFixed(2))
        : null,
      completedTime: this.completedTime
        ? Number((Number(this.completedTime) * 60).toFixed(2))
        : null,
      category: this.category,
      priority: this.priority,
      status: this.status,
      ticketUnitPrice: this.ticketUnitPrice && !isNaN(parseInt(this.ticketUnitPrice, 10))
        ? parseInt(this.ticketUnitPrice, 10)
        : null,
      milestone: this.milestone,
      eventOccurrenceVersion: this.eventOccurrenceVersion,
      completedReason: this.completedReason,
      supportPhase: this.supportPhase,
      importance: this.importance,
      eventOccurrenceTiming: this.eventOccurrenceTiming,
      eventSource: this.eventSource,
      supportScheduledDate: this.supportScheduledDate,
      releaseScheduledDate: this.releaseScheduledDate,
      confirmationDate: this.confirmationDate,
      freewordSearchText: this.freewordSearchText,
      childTasks: this.childTaskIds.map((id) => {
        return { childTaskId: id };
      }),
    };
    for (let i = 1; i <= 30; i++) {
      if (this[`customAttribute${i}ValueOption`] != null) {
        createTaskParam[`customAttribute${i}ValueOption`] =
          Number(this[`customAttribute${i}ValueOption`]);
      }
      createTaskParam[`customAttribute${i}ValueDate`] = this[
        `customAttribute${i}ValueDate`
      ];
      createTaskParam[`customAttribute${i}ValuePerson`] = this[
        `customAttribute${i}ValuePerson`
      ];
      createTaskParam[`customAttribute${i}ValueText`] = this[
        `customAttribute${i}ValueText`
      ];
      if (this[`customAttribute${i}ValueNumber`] != null) {
        createTaskParam[`customAttribute${i}ValueNumber`] =
          Number(this[`customAttribute${i}ValueNumber`]);
      }
    }
    this.isTaskAddModal = false;
    return createTaskParam as CreateTaskParam;
  }

  @Emit('closeTaskAddModal')
  private closeTaskAddModal(): void {
    this.isTaskAddModal = false;
  }
}
